<template>
    <div v-if="isLoading" class="brand-loader-wrapper">
        <brand-loader />
    </div>
    <excel-viewer :excel-details="excelDetails" :no-breadcrumb="props.noBreadcrumb" :display-mode="props.displayMode" :allow-comments-expand="props.allowCommentsExpand" v-else-if="excelDetails" />
    <no-pdf-view v-else-if="!isLoading" />
</template>

<script lang="ts" setup>

import { IExcelDetails } from '@/interfaces/deltaGpt/IDocument.ts';
import NoPdfView from '@/views/404View.vue';
import { ref } from 'vue';
import { deltaGptApi } from '@/api/deltaGpt/deltaGptApi.ts';
import BrandLoader from '@/components/layout/BrandLoader.vue';
import ExcelViewer from './ExcelViewer.vue';

const props = withDefaults(defineProps<{
    documentShortCode: string;
    noBreadcrumb?: boolean;
    displayMode?: 'page' | 'modal';
    allowCommentsExpand?: boolean;
}>(), {
    noBreadcrumb: false,
    displayMode: 'page',
    allowCommentsExpand: true,
});

const excelDetails = ref<IExcelDetails | undefined>();
const isLoading = ref<boolean>(false);

async function initialise (): Promise<void> {
    isLoading.value = true;
    try {
        excelDetails.value = await deltaGptApi.getExcelDetails(props.documentShortCode);
    } finally {
        isLoading.value = false;
    }
}

initialise();

</script>

<style lang="scss" scoped>
.brand-loader-wrapper {
    position: relative;
    height: 100%;
    min-height: 0;
}
</style>
